/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject, Injector } from '@angular/core';
import { PolygonSelectCommand } from './polygon-select.command';
import { Overlay } from '@angular/cdk/overlay';
import { Dialog } from '@angular/cdk/dialog';

export function polygonSelectFactory() {
    const command = new PolygonSelectCommand();
    command.setDependencies({
        injector: inject(Injector),
        dialog: inject(Dialog),
        overlay: inject(Overlay),
    });
    return command;
}
